export function getQueryParamsByName(name: string, url: string = window.location.search): string {
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex: RegExp = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	const results: string[] = regex.exec(url);

	if (!results)
		return null;

	if (!results[2])
		return '';

	return decodeURIComponent(results[2].replace(/\+/g, ''));
}

export function stripURLQueryParams(url: string = window.location.href): string {
	url = decodeURIComponent(url);
	return url.split(/[?#]/)[0];
}
